import $ from 'jquery';
import modaal from 'modaal';

class VideoHeroModal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {            
        $('.video-hero-cover-icon').modaal({
            content_source: '.video-hero-modaal',
            overlay_opacity: 0.6,
            custom_class: 'video-hero-modal',
            width: 950,
            overlay_close: true
        });

        $('.video-hero-cover-transcript').modaal({
            content_source: '.video-hero-transcript-modaal',
            overlay_opacity: 0.6,
            custom_class: 'video-hero-modal video-hero-transcript-modal',
            width: 842,
            overlay_close: true
        });

        // Close when clicking Modaal overlay
		$(document).on('click', (e) => {
			if ($(e.target).hasClass('modaal-outer-wrapper')) {
				$('.video-hero-cover-icon, .video-hero-cover-transcript').modaal('close');
			}
		});
    }
}

export default VideoHeroModal;

$(() => {
    const modal = new VideoHeroModal();
    modal.init();
});